
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vending-machine",
      function () {
        return require("private-next-pages/vending-machine.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vending-machine"])
      });
    }
  